<template>
  <div class="busca-container">

    <div class="row">
      <div class="col-sm-12 d-flex justify-content-between align-items-start">
        <div>
          <h2 class="d-none d-sm-block mb-1">Lista de Locações</h2>
          <h4 class="d-block d-sm-none mb-1">Lista de Locações</h4>
        </div>
        <div class="d-flex">
          <router-link v-if="getPermissao() == 1" to="/locacao" class="btn-criar mr-1">+ Criar Nova</router-link>
         <!-- <button class="btn-voltar" @click="$router.go(-1)">Voltar</button> -->
        </div>
      </div>
      <div class="col-sm-12"><br></div>
    </div>

    <!-- FORM DE BUSCA -->
    <div class="card busca-card mb-4">
      <div class="busca-card-header">
        <h5 class="mb-0">Filtros de Busca</h5>
      </div>
      <div class="busca-card-body">
        <form class="row" method="POST" ref="formularioBusca" @submit.prevent.stop="buscar">
          <div class="form-group col-sm-3">
            <label>Período:</label>
            <Datepicker @reset="resetarData" show-clear-button placeholder="De - Até" range v-model="selectedDate" lang="pt-br" date-format="formato"/>
          </div>

          <div class="form-group col-sm-3">
            <label>Pasta:</label>
            <input type="text" class="form-control" v-model="pasta" placeholder="">
          </div>

          <div class="form-group col-sm-3">
            <label>Referência:</label>
            <input type="text" class="form-control" v-model="referencia" placeholder="Imóvel / Referência">
          </div>

          <div class="form-group col-sm-3">
            <label>Locador:</label>
            <input type="text" class="form-control" v-model="locadorNome">
          </div>

          <div class="form-group col-sm-3">
            <label>Locatário:</label>
            <input type="text" class="form-control" v-model="locatarioNome">
          </div>

          <div class="form-group col-sm-3">
            <label>Garantia:</label>
            <select class="form-control" name="garantia" v-model="garantia">
              <option value="">Nenhuma</option>
              <option value="Fiador">Fiador</option>
              <option value="Titulo">Titulo</option>
              <option value="Seguro">Seguro</option>
              <option value="Caução">Caução</option>
            </select>
          </div>

          <div class="col-sm-3 d-flex align-items-end">
            <button ref="buscar" type="submit" class="btn-buscar w-100">Buscar</button>
          </div>
          <div class="col-sm-3 d-flex align-items-end">
            <button class="btn-limpar w-100" @click="limpar" type="button">Limpar</button>
          </div>
        </form>

        <div class="filtro-vencimento mt-4">
          <p class="filtro-label">Vencimentos:</p>
          <div class="d-flex flex-wrap">
            <button @click="buscar(10)" class="btn-filtro-pill pill-info mr-1">Até dia 10</button>
            <button @click="buscar(20)" class="btn-filtro-pill pill-warning mr-1">Dia 11 - 20</button>
            <button @click="buscar(30)" class="btn-filtro-pill pill-success mr-1">Dia 21 - 30</button>
            <router-link :to="`/relatorioBoletos`" class="btn-filtro-pill pill-primary ml-1">Visualizar Boletos</router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- TABELA -->
    <div class="row">
      <div class="col-12">
        <div class="card busca-card">
          <div class="busca-card-header">
            <h5 class="mb-0">Resultados</h5>
          </div>
          <div class="busca-card-body">
            <div class="table-responsive">
              <table class="table table-docs mb-0">
                <thead>
                  <tr>
                    <th>Pasta</th>
                    <th>Referência</th>
                    <th>Locador</th>
                    <th>Locatário</th>
                    <th>Início</th>
                    <th>Aluguel</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="loading">
                    <td colspan="7" class="text-center">
                      <div class="spinner-border text-muted" role="status" style="max-height:40px;">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </td>
                  </tr>
                  <tr v-for="item in locacoes" :key="item.LOC_ID">
                    <td>{{item.LOC_PASTA}}</td>
                    <td>{{item.LOC_IMOVEL}}</td>
                    <td>{{item.LOC_LOCADOR}}</td>
                    <td>{{item.LOC_LOCATARIO}}</td>
                    <td>{{item.LOC_INICIO_CONTRATO}}</td>
                    <td class="valor-cell">R$ {{item.LOC_ALUGUEL}}</td>
                    <td class="text-right">
                      <router-link :to="'/locacao/' + item.LOC_PASTA" class="btn-ver">VER</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="text-center mt-4">
              <button @click="paginar" ref="paginar" type="submit" class="btn-carregar-mais">Mais Resultados</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'BuscaLocacoes',

  data(){
    return {
      garantia:'',
      locacoes: [],
      loading: false,
      referencia: '',
      locadorNome: '',
      locatarioNome: '',
      pasta: '',
      selectedDate: [],
      formato:{day: '2-digit',month: '2-digit',year: 'numeric' }
    }
  },

  methods:{
    getUsuario(){
      return sessionStorage.getItem('imobiliariaNome');
    },
    getPermissao(){
      return sessionStorage.getItem('imobiliaria');
    },
    resetarData(){
      this.selectedDate = [];
    },
    limpar(){
      this.referencia = '';
      this.locadorNome = '';
      this.locatarioNome = '';
      this.pasta = '';
      this.selectedDate = [];
    },

    get(){
      let fm = new FormData();
      fm.append('permissao', this.getPermissao());
      fm.append('corretor', this.getUsuario());
      fm.append('paginacao', 0);

      this.loading = true;
      axios
        .post('https://www2.royaljardim.com.br/sistema/locacao/getLocacoes', fm)
        .then(response => this.locacoes = response.data)
        .catch(err => console.log(err))
        .finally(() => this.loading = false);
    },

    buscar(vencimento = null){
      this.loading = true;
      let fm = new FormData(this.$refs["formulario"]);
      fm.append('permissao', this.getPermissao());
      fm.append('corretor', this.getUsuario());
      fm.append('paginacao', 0);
        fm.append('pasta', this.pasta);
        fm.append('locadorNome', this.locadorNome);
        fm.append('locatarioNome', this.locatarioNome);
           fm.append('referencia', this.referencia);
            fm.append('garantia', this.garantia);

            if(vencimento){
              fm.append('vencimento', vencimento);
            }

      // filtro de data
      if(this.selectedDate.length > 0){
        let dd = this.selectedDate[0].toISOString().split("T")[0];
        let dd2 = this.selectedDate[1].toISOString().split("T")[0];
        fm.append('de', dd + " 00:00");
        fm.append('ate', dd2 + " 23:59");
      }

      axios
        .post('https://www2.royaljardim.com.br/sistema/locacao/busca', fm)
        .then(response => {this.locacoes = response.data;console.log(response.data)})
        .catch(err => console.log(err))
        .finally(() => this.loading = false);
    },

    paginar(){
      this.loading = true;
      let fm = new FormData(this.$refs["formulario"]);
      fm.append('permissao', this.getPermissao());
      fm.append('corretor', this.getUsuario());
      fm.append('paginacao', this.locacoes.length);
      fm.append('pasta', this.pasta);
        fm.append('locadorNome', this.locadorNome);
        fm.append('locatarioNome', this.locatarioNome);
           fm.append('referencia', this.referencia);

      axios
        .post('https://www2.royaljardim.com.br/sistema/locacao/busca', fm)
        .then(response => response.data.forEach(l => this.locacoes.push(l)))
        .catch(err => console.log(err))
        .finally(() => this.loading = false);
    }
  },

  mounted(){
    this.get();
  }
}
</script>

<style scoped>
/* ===== Container ===== */
.busca-container {
  max-width: 1100px;
  margin: 0 auto;
}

/* ===== Cards ===== */
.busca-card {
  border: 1px solid #e8e4e3;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.busca-card-header {
  background: #4C1C17;
  color: #fff;
  padding: 12px 20px;
  border-radius: 10px 10px 0 0;
}
.busca-card-header h5 {
  color: #fff;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 14px;
}
.busca-card-body {
  padding: 20px;
  background: #fff;
  border-radius: 0 0 10px 10px;
}

/* ===== Título ===== */
.busca-container h2,
.busca-container h4 {
  color: #4C1C17;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* ===== Labels e Inputs ===== */
.busca-card label {
  color: #4C1C17;
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 5px;
}
.busca-card .form-control {
  border-radius: 6px;
  border: 1px solid #ddd;
  padding: 9px 12px;
  font-size: 14px;
  transition: all 0.2s;
}
.busca-card .form-control:focus {
  border-color: #4C1C17;
  box-shadow: 0 0 0 3px rgba(76,28,23,0.1);
}

/* ===== Filtro Vencimento ===== */
.filtro-label {
  color: #4C1C17;
  font-weight: 700;
  font-size: 13px;
  text-transform: uppercase;
  margin-bottom: 8px;
}
.btn-filtro-pill {
  display: inline-block;
  padding: 8px 22px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  border: none;
  transition: all 0.2s;
  text-decoration: none;
}
.btn-filtro-pill:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0,0,0,0.15);
  color: #fff;
  text-decoration: none;
}
.pill-info {
  background: #e3f2fd;
  color: #0d6efd;
  border: 1px solid rgba(13,110,253,0.2);
}
.pill-info:hover { background: #0d6efd; color: #fff; }
.pill-warning {
  background: #fff8e1;
  color: #b8860b;
  border: 1px solid rgba(212,160,23,0.3);
}
.pill-warning:hover { background: #d4a017; color: #fff; }
.pill-success {
  background: #e8f5e9;
  color: #28a745;
  border: 1px solid rgba(40,167,69,0.25);
}
.pill-success:hover { background: #28a745; color: #fff; }
.pill-primary {
  background: #e3f2fd;
  color: #0d6efd;
  border: 1px solid rgba(13,110,253,0.2);
}
.pill-primary:hover { background: #0d6efd; color: #fff; }

/* ===== Botões ===== */
.btn-criar {
  background: linear-gradient(135deg, #d4a017, #b8860b);
  color: #fff;
  border: none;
  padding: 10px 22px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  transition: all 0.2s;
  box-shadow: 0 3px 10px rgba(212,160,23,0.3);
  text-decoration: none;
  white-space: nowrap;
}
.btn-criar:hover {
  background: linear-gradient(135deg, #e6b422, #d4a017);
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 5px 16px rgba(212,160,23,0.4);
  text-decoration: none;
}

.btn-voltar {
  background: linear-gradient(135deg, #6c757d, #495057);
  color: #fff;
  border: none;
  padding: 10px 22px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  transition: all 0.2s;
  white-space: nowrap;
}
.btn-voltar:hover {
  background: linear-gradient(135deg, #868e96, #6c757d);
  color: #fff;
  transform: translateY(-1px);
}

.btn-buscar {
  background: linear-gradient(135deg, #4C1C17, #6b2a22);
  color: #fff;
  border: none;
  padding: 10px 0;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-radius: 6px;
  transition: all 0.2s;
  box-shadow: 0 3px 10px rgba(76,28,23,0.3);
}
.btn-buscar:hover {
  background: linear-gradient(135deg, #6b2a22, #8a3530);
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 5px 16px rgba(76,28,23,0.4);
}

.btn-limpar {
  background: linear-gradient(135deg, #dc3545, #c82333);
  color: #fff;
  border: none;
  padding: 10px 0;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-radius: 6px;
  transition: all 0.2s;
  box-shadow: 0 3px 10px rgba(220,53,69,0.25);
}
.btn-limpar:hover {
  background: linear-gradient(135deg, #e8616c, #dc3545);
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 5px 16px rgba(220,53,69,0.35);
}

.btn-ver {
  display: inline-block;
  background: linear-gradient(135deg, #0d6efd, #0b5ed7);
  color: #fff;
  border: none;
  padding: 7px 18px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
  border-radius: 6px;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(13,110,253,0.3);
  text-decoration: none;
}
.btn-ver:hover {
  background: linear-gradient(135deg, #3184fd, #0d6efd);
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(13,110,253,0.4);
  text-decoration: none;
}

.btn-carregar-mais {
  background: linear-gradient(135deg, #d4a017, #b8860b);
  color: #fff;
  border: none;
  padding: 10px 40px;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-radius: 8px;
  transition: all 0.2s;
  box-shadow: 0 3px 10px rgba(212,160,23,0.3);
}
.btn-carregar-mais:hover {
  background: linear-gradient(135deg, #e6b422, #d4a017);
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 5px 16px rgba(212,160,23,0.4);
}

/* ===== Tabela ===== */
.table-docs thead {
  background: #4C1C17;
  color: #fff;
}
.table-docs th {
  padding: 12px 16px;
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border: none;
}
.table-docs td {
  padding: 12px 16px;
  vertical-align: middle;
  font-size: 14px;
}
.table-docs tbody tr:hover {
  background: #f8f4f3;
}
.table-docs tbody tr:last-child td {
  border-bottom: none;
}
.valor-cell {
  font-weight: 700;
  color: #4C1C17;
}

/* ===== Datepicker (Período) ===== */
.busca-card ::v-deep .input-field,
.busca-card ::v-deep .input-field.long {
  min-width: 0;
  width: 100%;
}
.busca-card ::v-deep .input-field input {
  width: 100%;
  max-width: 100%;
  height: 38px;
  padding-left: 36px;
  padding-right: 16px;
  font-size: 14px;
  border-radius: 6px;
  border: 1px solid #ddd;
  background: #fff;
  color: #495057;
  transition: all 0.2s;
}
.busca-card ::v-deep .input-field input:focus {
  border-color: #4C1C17;
  box-shadow: 0 0 0 3px rgba(76,28,23,0.1);
  outline: none;
}
.busca-card ::v-deep .content {
  top: 44px;
}
</style>